import format from './format'
export default date => (date === undefined ? '-' : format(date, 'HH:mm'))
